import type { SVGProps } from "react";
export interface Dice6IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Dice6Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Dice6IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M15 16.627a.62.62 0 0 0-.126.373l.014.126a.6.6 0 0 0 .113.246zm1 .745a.6.6 0 0 0 .112-.246l.014-.126-.014-.126a.6.6 0 0 0-.112-.247zM9.124 17A.62.62 0 0 0 9 16.628v.743A.62.62 0 0 0 9.125 17ZM8 16.628a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.245zm7-5.001a.62.62 0 0 0-.126.373l.014.127a.6.6 0 0 0 .113.244zm1 .744a.6.6 0 0 0 .112-.245l.014-.125-.014-.127a.6.6 0 0 0-.112-.247zm-6.888-.497A.6.6 0 0 0 9 11.628v.742a.6.6 0 0 0 .112-.243L9.125 12zM8 11.628a.62.62 0 0 0-.125.373l.012.126A.6.6 0 0 0 8 12.37zm7-5a.62.62 0 0 0-.126.372l.014.125a.6.6 0 0 0 .113.247v-.745Zm1 .744a.6.6 0 0 0 .112-.247L16.126 7l-.014-.126A.6.6 0 0 0 16 6.627zm-6.888-.498A.6.6 0 0 0 9 6.629v.741a.6.6 0 0 0 .112-.245L9.125 7zM8 6.629a.62.62 0 0 0-.125.37l.012.126A.6.6 0 0 0 8 7.37v-.74ZM10.126 17A1.625 1.625 0 1 1 8.5 15.376l.166.007c.82.083 1.46.776 1.46 1.617m6.999 0a1.624 1.624 0 0 1-3.242.166L13.876 17l.007-.166a1.625 1.625 0 0 1 1.617-1.458l.165.007c.82.083 1.46.775 1.46 1.617m-7-5a1.626 1.626 0 0 1-3.241.166l-.009-.165.009-.167a1.625 1.625 0 0 1 1.616-1.46l.166.01c.82.083 1.46.775 1.46 1.617Zm7 0a1.625 1.625 0 0 1-3.242.166l-.007-.165.007-.167a1.626 1.626 0 0 1 1.617-1.46l.165.01c.82.082 1.46.775 1.46 1.617Zm-7-5a1.625 1.625 0 0 1-3.242.167L6.876 7l.009-.166A1.625 1.625 0 0 1 8.5 5.375l.166.009c.82.083 1.46.774 1.46 1.616Zm7 0a1.625 1.625 0 0 1-3.242.167L13.876 7l.007-.166A1.626 1.626 0 0 1 17.125 7"
      />
    </svg>
  );
}
